/* eslint-disable no-underscore-dangle */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import btoa from 'btoa';
import {
  Container, Segment, Header, Card, Table, Button, List, Message,
  Popup, Input, Grid, Label,
} from 'semantic-ui-react';
import { Redirect } from 'react-router-dom';

import { getUserDisplayNameFromEmail } from '../../../helpers/format';
import { REGEX_PATTERNS, base, firebaseAuth, cloudFunctionsURL } from '../../../config/constants';
import { AlertBox, ConfirmBox, SelectBox, setAlertMsg, pickOne } from '../../../components/Modals';

export default class AddAdmin extends Component {
  static propTypes = {
    history: PropTypes.object,
    habilitations: PropTypes.object,
    match: PropTypes.object,
  }

  static defaultProps = {
    habilitations: { uid: null },
    match: { params: {} },
    history: null,
  }

  constructor(props) {
    super(props);
    this.state = {
      draftedAdmin: {
        email: null,
        habilitations: {},
      },
      draftedAdminId: null,
      savingAdmin: false,
      savingPreregistration: false,
      searchingUser: false,
      adding: {
        themes: false,
        citizenly: false,
        elected: false,
      },
    };
    this.fields = {
      email: null,
    };
  }

  componentDidMount() {
    this._ismounted = true;
    // console.log('did mount ', this.props);
    // base.bindToState('administrateurs', {
    //   context: this,
    //   state: 'admins',
    //   asArray: true,
    //   queries: {
    //     orderByChild: 'email',
    //     // limitToLast: 3
    //   },
    //   then: () => this.setState({ adminsLoading: false }),
    // });
    // if (this.props.match.params.id) {
    //   this.selectedBinding = base.bindToState(`administrateurs/${this.props.match.params.id}`, {
    //     context: this,
    //     state: 'selectedAdmin',
    //     then: () => this.setState({ selectedAdminLoading: false, selectedAdminId: this.props.match.params.id }),
    //   });
    // }
  }

  componentWillUnmount() {
    this._ismounted = false;
    clearTimeout(this.timeOutForSearchChange);
  }

  getFormattedList = (themeType) => {
    let wordNone;
    switch (themeType) {
      case 'themes':
        wordNone = 'Aucune profession';
        break;
      case 'citizenly':
        wordNone = 'Aucune commune';
        break;
      case 'elected':
        wordNone = 'Aucune circonscription';
        break;
      default:
        wordNone = '-';
        break;
    }

    if (
      !themeType
      || !this.state.draftedAdmin.habilitations[themeType]
      || Object.keys(this.state.draftedAdmin.habilitations[themeType]).length === 0
    ) {
      return wordNone;
    }
    // console.log(this.state.draftedAdmin.habilitations[themeType]);

    const themes = Object.keys(this.state.draftedAdmin.habilitations[themeType]);
    return (
      <List>
        {
          _.map(themes, item => (
            <List.Item key={item}>
              <List.Content>
                <Button
                  fluid
                  animated="fade"
                  color="blue"
                  compact
                  size="tiny"
                  disabled={this.state.savingAdmin || this.state.savingPreregistration}
                  onClick={() => this.handleDeleteThemeAccess(themeType, item)}
                >
                  <Button.Content visible>
                    {item.toUpperCase()}
                  </Button.Content>
                  <Button.Content hidden>
                    Supprimer
                  </Button.Content>
                </Button>
              </List.Content>
            </List.Item>
          ))
        }
      </List>
    );
  };

  resetComponent = (spreadMe = {}) => this.setState({
    ...spreadMe,
    draftedAdmin: {
      email: null,
      habilitations: {},
    },
    draftedAdminId: null,
    savingAdmin: false,
    savingPreregistration: false,
    searchingUser: false,
    adding: {
      themes: false,
      citizenly: false,
      elected: false,
    },
  })

  handleAddThemeAccess = (themeType) => {
    this.setState({ adding: { ...this.state.adding, [themeType]: true } });

    let word;
    switch (themeType) {
      case 'themes':
        word = 'une profession';
        break;
      case 'citizenly':
        word = 'une commune';
        break;
      case 'elected':
        word = 'une circonscription';
        break;
      default:
        word = '';
        break;
    }

    return base.fetch(`${themeType}`, {
      context: this,
      asArray: true,
    }).then((data) => {
      const options = _.map(data, source => ({
        key: source.key,
        value: source.key,
        text: `${source.nom} (${source.key})`,
      }));
      this.setState({
        ...pickOne(
          `Ajouter ${word}`,
          `Vous souhaitez ajouter un accès à ${word}.<br/>
           Pour cela, veuillez choisir ${word} dans la liste ci-dessous puis cliquer sur "Ajouter" :`,
          'create',
          (themeId) => {
            this.setState({
              draftedAdmin: {
                ...this.state.draftedAdmin,
                habilitations: {
                  ...this.state.draftedAdmin.habilitations,
                  [themeType]: {
                    ...this.state.draftedAdmin.habilitations[themeType],
                    [themeId]: true,
                  },
                },
              },
            });
          },
          options,
          'Ajouter',
          `Sélectionnez ${word}`,
        ),
        adding: { ...this.state.adding, [themeType]: false },
      });
    }).catch((error) => {
      this.setState({
        ...setAlertMsg(error.code || null, 'Impossible de récupérer la liste', error.toString(), 'error'),
        adding: { ...this.state.adding, [themeType]: false },
      });
    });
  }

  handleDeleteThemeAccess = (themeType, themeId) => {
    this.setState({
      draftedAdmin: {
        ...this.state.draftedAdmin,
        habilitations: {
          ...this.state.draftedAdmin.habilitations,
          [themeType]: _.omit(this.state.draftedAdmin.habilitations[themeType], themeId),
        },
      },
    });
  }

  handleFetchUser = (email) => {
    if (!REGEX_PATTERNS.email.test(email)) {
      return this.setState(setAlertMsg(
        null,
        'Adresse email invalide',
        'Veuillez saisir une adresse email valide avant de rechercher l\'utilisateur associé.',
        'error',
      ));
    }
    this.setState({ searchingUser: true });
    firebaseAuth().currentUser.getIdToken(/* forceRefresh */ false)
      .then(idToken => fetch(`${cloudFunctionsURL}/uidFromEmail/?email=${encodeURIComponent(email)}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      }).then(resp => resp.json()).then((data) => {
        if (data.found && data.user && data.user.uid) {
          return base.fetch(`administrateurs/${data.user.uid}`, {
            context: this,
          }).then((found) => {
            if (Object.keys(found).length !== 0) {
              return this.setState({
                ...setAlertMsg(
                  null,
                  'Impossible d\'ajouter cet administrateur',
                  'Cet utilisateur est <strong>déjà administrateur</strong>.<br/><br/>' +
                  'Pour administrer ses habilitations, cliquez sur<br/>"<em>Éditer les droits d\'un' +
                  ' administrateur</em>"',
                  'error',
                ),
                searchingUser: false,
              });
            }
            return this.setState({
              searchingUser: false,
              draftedAdmin: {
                ...this.state.draftedAdmin,
                email,
              },
              draftedAdminId: data.found && data.user ? data.user.uid : null,
            });
          }).catch(error => this.setState({
            ...setAlertMsg(error.code || null, 'Erreur lors de la recherche', error.toString(), 'error'),
            searchingUser: false,
          }));
        }
        return this.setState({
          searchingUser: false,
          draftedAdmin: {
            ...this.state.draftedAdmin,
            email,
          },
          draftedAdminId: data.found && data.user ? data.user.uid : null,
        });
      }))
      .catch(error => this.setState({
        ...setAlertMsg(error.code || null, 'Erreur lors de la recherche', error.toString(), 'error'),
        searchingUser: false,
      }));
    return true;
  }

  handleSubmit = () => {
    // console.log(this.state.draftedAdminId, this.state.draftedAdmin);
    this.setState({
      savingAdmin: this.state.draftedAdminId !== null,
      savingPreregistration: this.state.draftedAdminId === null,
    });
    if (this.state.draftedAdminId !== null) {
      base.post(
        `administrateurs/${this.state.draftedAdminId}`,
        { data: this.state.draftedAdmin },
      ).then(() => {
        this.resetComponent(setAlertMsg(
          null,
          'Administrateur ajouté',
          'Cet administrateur a bien été ajouté',
          'success',
        ));
      });
    } else {
      base.post(
        `adminPreinscriptions/${btoa(this.state.draftedAdmin.email)}`,
        { data: this.state.draftedAdmin },
      ).then(() => {
        this.resetComponent(setAlertMsg(
          null,
          'Administrateur préinscrit',
          'Cet administrateur a bien été préinscrit',
          'success',
        ));
      });
    }
  }

  handleToggleSuperuser = trueIfActivateRequest => this.setState({
    draftedAdmin: {
      ...this.state.draftedAdmin,
      habilitations: {
        ...this.state.draftedAdmin.habilitations,
        superuser: trueIfActivateRequest,
      },
    },
  })

  render() {
    // console.log(this.props.habilitations);
    // console.log(this.state.selectedAdmin);
    const noneSelected = this.state.draftedAdmin.email === null;
    const habObject = this.state.draftedAdmin.habilitations;
    const admin = this.state.draftedAdmin;

    if (
      this.props.match.params.id && !this.state.adminsLoading && !this.state.selectedAdminLoading
      && (noneSelected || !this.state.selectedAdmin.email)
    ) {
      return <Redirect to="/access-mgt/view" />;
    }

    return (
      <Container>
        <Segment basic>
          <Container text>
            <Segment textAlign="center" disabled={!noneSelected}>
              <Header textAlign="center" size="small">
                Recherchez un utilisateur par son adresse email
              </Header>
              <Input
                autoFocus
                action={
                  {
                    color: 'teal',
                    labelPosition: 'right',
                    icon: 'search',
                    content: 'Rechercher cet utilisateur',
                    loading: this.state.searchingUser,
                    disabled: !noneSelected,
                    onClick: () => {
                      this.handleFetchUser(this.fields.email);
                    },
                  }
                }
                fluid
                type="email"
                disabled={this.state.searchingUser || !noneSelected}
                placeholder="Saisir une adresse email"
                onChange={(e, { value }) => {
                  this.fields.email = value.toLowerCase();
                }}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    this.handleFetchUser(this.fields.email);
                  }
                }}

              />
              {noneSelected ? (
                <Message compact size="tiny">
                  <Message.Header size="mini">Ensuite, deux possibilités...</Message.Header>
                  <Message.List>
                    <Message.Item>
                      <strong>Soit l'utilisateur est déjà inscrit à ViGie</strong> et vous pourrez configurer ses
                      habilitations et il sera immédiatement ajouté au groupe des administrateurs.
                    </Message.Item>
                    <Message.Item>
                      <strong>Soit l'utilisateur n'est pas encore inscrit à ViGie</strong>, vous pourrez alors
                      pré-configurer les habilitations que recevra l'utilisateur lorsqu'il s'inscrira en utilisant cette
                      adresse comme identifiant.
                    </Message.Item>
                  </Message.List>
                </Message>
              ) : (
                <Message compact>
                  Pour choisir un autre utilisateur, vous devez annuler votre saisie à l'aide du bouton en bas de page.
                </Message>
              )}
            </Segment>
          </Container>
          <Segment basic disabled={noneSelected}>
            <Card fluid raised={!noneSelected}>
              <Card.Content>
                <Card.Header
                  size="small"
                  content={
                    !noneSelected ?
                      getUserDisplayNameFromEmail(admin.email) : '-'
                  }
                />
                <Card.Meta
                  content={
                    !noneSelected ?
                      admin.email : 'Aucun utilisateur sélectionné'
                  }
                />
              </Card.Content>
              <Card.Content>
                <Label as="span" color={this.state.draftedAdminId ? 'green' : 'black'} ribbon>
                  {
                    this.state.draftedAdminId
                      ? 'Utilisateur existant' : 'Préinscription'
                  }
                </Label>
                <Card.Meta
                  content="Habilitations du nouvel administrateur"
                />
                <Table definition={!noneSelected} color={!noneSelected ? 'blue' : null}>
                  <Table.Body>
                    <Table.Row disabled={noneSelected}>
                      <Table.Cell>Super administrateur</Table.Cell>
                      <Table.Cell>
                        <Button
                          fluid
                          animated="fade"
                          color={
                            noneSelected || !habObject.superuser
                              ? null : 'red'
                          }
                          disabled={noneSelected || this.state.savingAdmin || this.state.savingPreregistration}
                          onClick={
                            () => noneSelected
                              || this.handleToggleSuperuser(!habObject.superuser)
                          }
                        >
                          <Button.Content visible>
                            {noneSelected || !habObject.superuser ? 'Désactivé' : 'Activé'}
                          </Button.Content>
                          <Button.Content hidden>
                            {noneSelected || !habObject.superuser ? 'Activer' : 'Désactiver'}
                          </Button.Content>
                        </Button>
                      </Table.Cell>
                      <Table.Cell />
                    </Table.Row>
                    <Table.Row disabled={noneSelected}>
                      <Table.Cell>Professionnels</Table.Cell>
                      <Table.Cell textAlign="center">{this.getFormattedList('themes')}</Table.Cell>
                      <Table.Cell collapsing>
                        <Popup
                          trigger={
                            <Button
                              icon="add"
                              color="green"
                              inverted
                              circular
                              disabled={noneSelected || this.state.savingAdmin || this.state.savingPreregistration}
                              loading={this.state.adding.themes}
                              onClick={() => this.handleAddThemeAccess('themes')}
                            />
                          }
                        >
                          <Popup.Content>Ajouter une profession</Popup.Content>
                        </Popup>
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row disabled={noneSelected}>
                      <Table.Cell>Participation Citoyenne</Table.Cell>
                      <Table.Cell textAlign="center">{this.getFormattedList('citizenly')}</Table.Cell>
                      <Table.Cell collapsing>
                        <Popup
                          trigger={
                            <Button
                              icon="add"
                              color="green"
                              inverted
                              circular
                              disabled={noneSelected || this.state.savingAdmin || this.state.savingPreregistration}
                              loading={this.state.adding.citizenly}
                              onClick={() => this.handleAddThemeAccess('citizenly')}
                            />
                          }
                        >
                          <Popup.Content>Ajouter une commune</Popup.Content>
                        </Popup>
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row disabled={noneSelected}>
                      <Table.Cell>Contact Élus</Table.Cell>
                      <Table.Cell textAlign="center">{this.getFormattedList('elected')}</Table.Cell>
                      <Table.Cell collapsing>
                        <Popup
                          trigger={
                            <Button
                              icon="add"
                              color="green"
                              inverted
                              circular
                              disabled={noneSelected || this.state.savingAdmin || this.state.savingPreregistration}
                              loading={this.state.adding.elected}
                              onClick={() => this.handleAddThemeAccess('elected')}
                            />
                          }
                        >
                          <Popup.Content>Ajouter une circonscription</Popup.Content>
                        </Popup>
                      </Table.Cell>
                    </Table.Row>
                  </Table.Body>
                </Table>
              </Card.Content>
              <Card.Content>
                <Segment basic textAlign="center">
                  <Grid columns={2}>
                    <Grid.Row>
                      <Grid.Column>
                        <Button
                          content="Annuler la saisie"
                          fluid
                          icon="cancel"
                          labelPosition="left"
                          color="grey"
                          onClick={() => this.resetComponent()}
                          disabled={noneSelected || this.state.savingAdmin || this.state.savingPreregistration}
                        />
                      </Grid.Column>
                      <Grid.Column>
                        <Button
                          content={
                            this.state.draftedAdminId
                              ? 'Valider l\'ajout de cet administrateur' : 'Préinscrire cet administrateur'
                          }
                          icon="add"
                          fluid
                          positive
                          labelPosition="right"
                          onClick={() => this.handleSubmit()}
                          loading={this.state.savingAdmin || this.state.savingPreregistration}
                          disabled={noneSelected}
                        />
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Segment>
              </Card.Content>
            </Card>
          </Segment>
        </Segment>
        <AlertBox
          propagateClosure={() => this.setState({ alert: { open: false } })}
          {...this.state.alert}
        />
        <ConfirmBox
          propagateClosure={() => this.setState({ confirm: { open: false } })}
          {...this.state.confirm}
        />
        <SelectBox
          propagateClosure={() => this.setState({ pick: { open: false } })}
          {...this.state.pick}
        />
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/protected/AccessManagement/AddAdmin.js